import { css, html, LitElement } from "lit"

export default class PageAPropos extends LitElement {
  static properties = {}

  static styles = css``

  render() {
    return html`<main>
  <header>
    <h1>Page à propos</h1>
    <p>Cette application a été développée par <a href="https://github.com/luminecence">luminecence</a>.</p>
  </header>

  <section>
    <h2>Qui suis-je ?</h2>
    
    <article>
      <p>Je suis un développeur d'une trentaine d'années passionné par les technologies web et les Pokémon. J'ai créé cette application mobile pour permettre aux joueurs de Pokémon Go d'échanger facilement leurs Pokémon avec d'autres joueurs.</p>
      
      <p>Avec ma petite bande d'amis, quand c'est l'heure des échanges...</p>
      
      <p>J'en ai également profité pour faire quelques tests techniques pour voir un petit peu ce que je savais faire et apprendre de nouvelles choses.</p>
    </article>
  </section>

  <section>
    <h3>Me contacter</h3>
    <p>Si vous avez des questions, des suggestions ou si vous souhaitez contribuer au projet, n'hésitez pas à me contacter via <a href="mailto:luminecence.dev@gmail.com">email</a> ou par <a href="https://discord.com/users/342627083463426049" target="_blank" rel="noopener noreferrer">mp sur Discord</a>.</p>
  </section>
</main>`
  }
}
customElements.define("p-page-a-propos", PageAPropos)
